module.exports = {
      id: "cinema-usage",
      viewBox: "0 0 26.501 25.377",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#cinema",
      toString: function () {
        return this.url;
      }
    }